import { WeatherStation } from '../../models/field-context';

/**
 * The line under the irrigation chart's heading that names where its weather comes from. Until
 * October 2026 every Southern Gateway field showed the Southern Farms station whatever its tenant,
 * so the source is spelled out rather than left to be assumed.
 *
 * Three states, kept apart on purpose:
 * - a station: "Weather: SGS Orange Falls (03114BDE)", or "Weather: station 03114BDE" with no name;
 * - null, the sync service saying the field's tenant has no active station: "Weather: no station linked";
 * - undefined, not known (context still loading, the call failed, or an older sync service): no line.
 *   A failed call must never read as "no station".
 */
export function weatherSourceLabel(station: WeatherStation | null | undefined): string {
  if (station === undefined) return '';
  if (station === null) return 'Weather: no station linked';
  const name = (station.customName ?? '').trim();
  return name ? `Weather: ${name} (${station.code})` : `Weather: station ${station.code}`;
}
